// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ZZU2","bigColWidth":"Table_bigColWidth__344Ys","biggerColWidth":"Table_biggerColWidth__oTXA_","row":"Table_row__2OCMc","col":"Table_col__33-hA"};